<template>
  <div class="relative">
    <div id="filters" class="font-inter">
      <form class="shadow-md rounded px-8 pt-6 pb-8 flex flex-col xl:flex-row">
        <div class="mt-4 xl:mt-0 mb-4 pr-5">
          <label class="block text-white text-sm font-bold mb-2" for="username">
            {{ $t("profit.startBalance")}}
          </label>
          <input class="shadow appearance-none border rounded  border-gray-600 w-full py-2 px-3 text-black bg-gray-950 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" v-model="amount">
        </div>
        <div class="mt-4 xl:mt-0 mb-4">
          <label class="block text-white text-sm font-bold mb-2" for="username">
            {{ $t("profit.startDate")}}
          </label>
          <input min="2017-01-01" max="2023-12-01" class="shadow appearance-none border rounded  border-gray-600 w-full py-2 px-3 text-black bg-gray-950 leading-tight focus:outline-none focus:shadow-outline" id="username" type="date" v-model="startDate">
        </div>
        <div class="mt-4 xl:mt-0 xl:pl-5 mb-4">
          <label class="block text-white text-sm font-bold mb-2" for="username">
            {{ $t("profit.endDate")}}
          </label>
          <input min="2017-01-01" max="2023-04-05" class="shadow appearance-none border rounded  border-gray-600 w-full py-2 px-3 text-black bg-gray-950 leading-tight focus:outline-none focus:shadow-outline" id="username" type="date" v-model="endDate">
        </div>
      </form>
    </div>

    <div id="chart" ref="chartContainer"></div>
  </div>
</template>

<script>
import { createChart } from 'lightweight-charts';

export default {
  data() {
    return {
      chart: null,
      series: null,
      amount: 10000,
      startDate: '2017-01-01',
      endDate: '2023-04-05',
      dataPercent: [],
      toolTip: null,
      legend: null,
      firstRow: null,
      chartContainer: null,
      toolTipWidth: 100,
      toolTipHeight: 100,
      toolTipMargin: 15,
    };
  },
  
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fitContent() {
      if (!this.chart) return;
      this.chart.timeScale().fitContent();
    },
    getChart() {
      return this.chart;
    },
    addSeriesAndData() {
      this.series = this.chart.addAreaSeries({
        topColor: 'rgba(38,198,218, 0.56)',
        bottomColor: 'rgba(38,198,218, 0.04)',
        lineColor: 'rgba(38,198,218, 1)',
        lineWidth: 2,
      });
      this.recreate();
      //this.chart.timeScale().fitContent();
    },
    drawChart() {
      
      this.chart = createChart(this.$refs.chartContainer, {
        watermark: {
          visible: true,
          fontSize: 24,
          horzAlign: 'center',
          vertAlign: 'center',
          color: 'rgba(171, 71, 188, 0.5)',
          text: 'Eronto profit calculator',
        },
        height: 500,
        autoscaleInfo: {

        },
        priceScale: {
          autoScale: true,
        },
        rightPriceScale: {
          scaleMargins: {
            top: 0.3,
            bottom: 0.25,
          },
          borderVisible: false,
        },
        layout: {
          background: {
                  type: 'solid',
                  color: '#131722',
              },
          textColor: '#d1d4dc',
        },
        grid: {
          vertLines: {
            color: 'rgba(42, 46, 57, 0)',
          },
          horzLines: {
            color: 'rgba(42, 46, 57, 0.6)',
          },
        },
      });
      this.addSeriesAndData();

      // update tooltip
      this.chart.subscribeCrosshairMove(param => {

      if (
        param.point === undefined ||
        !param.time ||
        param.point.x < 0 ||
        param.point.x > this.chartContainer.clientWidth ||
        param.point.y < 0 ||
        param.point.y > this.chartContainer.clientHeight
      ) {
        this.toolTip.style.display = 'none';
      } else {
        let ytd = '0.00';
        if (param.time != this.startDate) {
          ytd = (parseFloat(this.dataPercent[param.time.replaceAll("-", "")]) * 100).toFixed(2);
        }
        // time will be in the same format that we supplied to setData.
        // thus it will be YYYY-MM-DD
        const dateStr = param.time;
        this.toolTip.style.display = 'block';
        const data1 = param.seriesData.get(this.series);

        const price =  data1.value !== undefined ? data1.value : data1.close;
        

        this.toolTip.innerHTML = `<div><span style="color: white">` + this.$i18n.t('profit.year')+ `</span><span style="color: green"> ${ ytd }%</span></div><br/><div><span style="color: white">Balance </span><span style="color: green">$${this.numberWithCommas(Math.round(100 * price) / 100)}</span></div>
          `;

        const y = param.point.y;
        let left = param.point.x + this.toolTipMargin;
        if (left > this.chartContainer.clientWidth - this.toolTipWidth) {
          left = param.point.x - this.toolTipMargin - this.toolTipWidth;
        }

        
        let top = y + this.chartContainer.offsetTop;
      
        this.toolTip.style.left = left + 'px';
        this.toolTip.style.top = top + 'px';
        this.toolTip.style.height = this.toolTipHeight + 'px';
      }
      });
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    recreate() {
      this.dataPercent = [];
      this.dataPercent[20170101] = 0;
      this.dataPercent[20180101] = 0.9813;
      this.dataPercent[20190101] = -0.0102;
      this.dataPercent[20200101] = 0.4052;
      this.dataPercent[20210101] = 1.622;
      this.dataPercent[20220101] = 2.2731;
      this.dataPercent[20230101] = 1.2711;
      this.dataPercent[20231201] = 0.5448;
      let startDateValue = this.startDate;
      let endDateValue = this.endDate;
      let endDate2 = parseInt(endDateValue.substring(0,4));
      let startDate2 = parseInt(startDateValue.substring(0,4));
      let startMonth =   startDateValue.substr(5,2);
      let endMonth =   endDateValue.substr(5,2);

      let remainingMonths =  12 - startMonth;
      if (remainingMonths == '11') {
        remainingMonths = 12;
      }

      let dataSeries = [];
      let index = 0;
      let c = 0;
      let lastIndex = 0.00;
      let amount = 0.00;
      for (let i=endDate2; startDate2 <= i; startDate2++) {
        if (c == 0) {

        } else {
          if (c == 1) {
            index = index + ((this.dataPercent[startDate2 + '0101'] / 12) * remainingMonths);
            this.dataPercent[startDate2 + startMonth +'01'] = ((this.dataPercent[startDate2 + '0101'] / 12) * remainingMonths);
            lastIndex = ((this.dataPercent[startDate2 + '0101'] / 12) * remainingMonths);
          } else {
            index = index + this.dataPercent[startDate2 + '0101'];
            lastIndex = this.dataPercent[startDate2 + '0101'];
          }
        }
        c++;
        dataSeries.push({ time: startDate2 + '-'+ startMonth +'-01', value: parseFloat(this.amount) + (parseFloat(this.amount) *  index) })
        amount = parseFloat(this.amount) + (parseFloat(this.amount) * index);
        startMonth = '01';
      }
      index = index + this.dataPercent[20231201];
      
      if (endDate2 == 2023 && endMonth == '12') {
        dataSeries.push({ time: '2023-12-01', value: parseFloat(this.amount) + (parseFloat(this.amount) * index) });
        amount = parseFloat(this.amount) + (parseFloat(this.amount) * index);
      }
      this.firstRow.innerText = this.$i18n.t('profit.current') + ': $' + '  ' + this.numberWithCommas(amount.toFixed(2)) + ' - ' + this.$i18n.t('profit.year') +': ' + (lastIndex * 100).toFixed(2) + '%';

      this.series.setData(dataSeries);
      this.chart.timeScale().fitContent();
    },
  },
  mounted() {
    this.chartContainer = this.$refs.chartContainer;

    let container = document.getElementById('chart');
    this.toolTip = document.createElement('div');
    this.toolTip.style = `width: 96px; height: 80px; position: absolute; display: none; padding: 8px; box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; left: 12px; pointer-events: none; border: 1px solid; border-radius: 2px;font-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
    this.toolTip.style.background = '#18363B';
    this.toolTip.style.color = 'black';
    this.toolTip.style.borderColor = 'green';
    container.appendChild(this.toolTip);


    this.legend = document.createElement('div');
    let moveLeft = '600px';
    let moveTop = '70px';
    if (this.isMobile()) {
      moveLeft = '0px';
      moveTop = '320px';
    }
    this.legend.style = `width: 380px; height: 80px; position: absolute;z-index: 1000; top: ${moveTop}; left: ${moveLeft};`;
    this.legend.classList.add('legend');
    container.appendChild(this.legend);

    this.firstRow = document.createElement('div');
    this.firstRow.innerText = this.$i18n.t('profit.current') + ': $75,425.00 - ' + this.$i18n.t('profit.year') + ': 127.11%';
    this.firstRow.style.color = 'white';
    this.legend.appendChild(this.firstRow);

    this.drawChart();
  },
  beforeDestroy() {
    // Your beforeDestroy hook remains the same
  },
  watch: {
    amount(count, prevCount) {
      if (!this.series) return;
      this.recreate();
    },
    startDate(count, prevCount) {
      if (!this.series) return;
      this.recreate();
    },
    endDate(count, prevCount) {
      if (!this.series) return;
      this.recreate();
    },
  },
};
</script>

<style scoped>

</style>